import React from 'react'
import clsx from 'clsx'
import { format } from 'date-fns'
import { useTheme } from '@mui/material'

import OverflowText from '../../../atoms/OverflowText'

import { useBreakpoint } from '../../../../providers/BreakpointProvider'
import useStyles from './styles'

const UserJoinedAlert = ({ sender, date, name }) => {
  const theme = useTheme()

  const { isSmall } = useBreakpoint()

  const classes = useStyles()

  const formattedDate = React.useMemo(
    () => format(new Date(date), 'MMM d, h:mm aaa'),
    [date]
  )

  const message = React.useMemo(() => {
    if (name) {
      return (
        <OverflowText>
          <span>
            <label>
              <span>
                <span style={{ fontWeight: theme.bold.bold }}>{sender}</span>{' '}
                was added by{' '}
                <span style={{ fontWeight: theme.bold.bold }}>{name}</span>
              </span>
              <span
                style={{
                  marginLeft: '0.25rem'
                }}
              >
                {formattedDate}
              </span>{' '}
            </label>
          </span>
        </OverflowText>
      )
    }

    return (
      <OverflowText>
        <span>
          <span style={{ fontWeight: theme.bold.bold }}>{sender}</span> joined
          the conversation
          <span
            style={{
              marginLeft: '0.25rem'
            }}
          >
            {formattedDate}
          </span>
        </span>
      </OverflowText>
    )
  }, [sender, name, formattedDate, theme])

  const mobileMessage = React.useMemo(() => {
    if (name) {
      return (
        <OverflowText>
          <label className={clsx(classes.mobileHeader, classes.truncate)}>
            <span style={{ fontWeight: theme.bold.bold }}>{sender}</span> was
            added by <span style={{ fontWeight: theme.bold.bold }}>{name}</span>
          </label>
          <label className={classes.mobileHeaderDate}>{formattedDate}</label>
        </OverflowText>
      )
    }

    return (
      <OverflowText>
        <label className={clsx(classes.mobileHeader, classes.truncate)}>
          <span style={{ fontWeight: theme.bold.bold }}>{sender}</span> joined
          the conversation
        </label>

        <label className={classes.mobileHeaderDate}>{formattedDate}</label>
      </OverflowText>
    )
  }, [sender, name, formattedDate, classes, theme])

  if (name === 'own' || sender === name) {
    return null
  }

  return <div className={classes.root}>{isSmall ? mobileMessage : message}</div>
}

export default UserJoinedAlert
